import React from "react";
import "./EventCard.css";

export default function EventCard({ event = {}, onClick }) {
  const {
    event_name,
    title,
    name,
    date_label,
    date_time_label,
    time_label,
    event_location,
    location,
    event_cost,
    image_url,
    event_type,
    event_url,
  } = event;

  const TAG_CLASS = {
    Cowork: "cowork",
    "Concert": "concert",
    "Workshop": "workshop",
    "Art": "art",
    "Happy Hour": "happy-hour",
  };

  const tagClass = TAG_CLASS[event_type] || "default";
  const displayTitle = event_name || title || name || "Untitled event";
  const displayLocation = event_location || location || "";

  function handleCardClick() {
    if (onClick) onClick();
    if (event_url) window.open(event_url, "_blank", "noreferrer");
  }

  return (
    <div className="eventCard" onClick={handleCardClick} role="button">
      <div className="eventMedia">
        {image_url ? (
          <img className="eventImg" src={image_url} alt="" loading="lazy" />
        ) : (
          <div className="eventImgPlaceholder" aria-hidden="true" />
        )}
        {event_type ? <div className={`eventTag ${tagClass}`}>{event_type}</div> : null}
      </div>

      <div className="eventBody">
        <div className="eventTitleRow">
          <h3 className="eventTitle">{displayTitle}</h3>
        </div>
        <div className="eventMeta">
          {date_label || date_time_label || null} |{" "}
          {time_label ? <span className="eventSub">{time_label}</span> : null}
        </div>
        <div className="eventLocation">{displayLocation}</div>
        <div className="eventPrice">{event_cost || ""}</div>
        {event_url && (
          <a
            href={event_url}
            target="_blank"
            rel="noreferrer"
            className="eventRsvpBtn"
            onClick={(e) => e.stopPropagation()}
          >
            RSVP →
          </a>
        )}
      </div>
    </div>
  );
}
